import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {

  transform(value: string): string {
    // Assuming value is in the format 'HH:mm:ss'
    const [hours, minutes] = value.split(':');
    return `${hours}:${minutes}`;
  }

}
